module.exports = __webpack_public_path__ + "28e2745a84338556339b0c8cb73fac63.MP3";